<script>
import axios from "axios";

export default {
  name: 'LeafImport',

  props: {
    user: {
      required: true,
      type: Object,
    },
    farm: {
      required: true,
      type: Object,
    },
    agFields: {
      required: true,
      type: Array,
    },
    currentFields: {
      required: true,
      type: Object,
    },
    activeProviders: {
      required: false,
      type: Array,
    },
    providers: {
      required: true,
      type: Object,
    },
    jdAuthUrl: {
      required: true,
      type: String,
    },
    connected: {
      required: true,
      type: Boolean,
    },
    routes: {
      required: true,
      type: Object,
    },
    prevPageLink: {
      required: false,
      type: String,
      default: null,
    },
    nextPageLink: {
      required: false,
      type: String,
      default: null,
    },
    importedIds: {
      required: false,
      type: Object,
      default: [],
    },
    orgName: {
      required: true,
      type: String
    }
  },

  data() {
    return {
      leafUserId: null,
      tokenUrls: null,
      selectedProviders: [],
      disable: false,
      page: 1,
      checkedFields: [],
      waitingForFields: false,
      activeProvider: 2, // Hardcoded to Deere
      nextPage: false,
      prevPage: false,
      importBoundariesOnly: true,
    };
  },

  created() {
    if (this.user.leaf_id) {
      this.leafUserId = this.user.leaf_id
    }

    if (this.connected) {
      this.page = 3
      this.nextPage = this.nextPageLink
      this.prevPage = this.prevPageLink
    } else if (!this.connected && this.user.deere_connected_at) {
      this.page = 2
    }

    this.getProviderTokenUrls()
  },

  methods: {
    getProviderTokenUrls() {
      axios.get(this.routes['precision-ag.token.urls'] + '?' + this.urlParams({
        providers: Object.keys(this.providers),
        user_id: this.user.id
      })).then((response) => {
        this.tokenUrls = response.data.urls
      })
    },
    importFields() {
      let fieldIds = []
      Object.values(this.checkedFields).forEach(function (item, index) {
        fieldIds.push(item.id)
      });

      this.waitingForFields = true
      this.page = 4

      axios.post(this.routes['precision-ag.import'] + '?' + this.urlParams({
        fields: fieldIds,
        user_id: this.leafUserId,
        boundaries_only: this.importBoundariesOnly ? 1 : 0,
      })).then((response) => {
        this.waitingForFields = false
      })
    },
    dispatchImport() {
      axios.put(this.routes['precision-ag.provider.import'] + '?user_id=' + this.user.id).then((response) => {
        location.reload();
      })
    },
    toggleCheckFields(checkAll) {
      if (checkAll) {
        this.checkedFields = this.agFields
      } else {
        this.checkedFields = []
      }
    },
    urlParams(myData) {
      let out = [];
      for (let key in myData) {
        if (myData.hasOwnProperty(key)) {
          out.push(key + '=' + encodeURIComponent(myData[key]));
        }
      }
      return out.join('&');
    },
    getFields(link) {
      axios.get(this.routes['precision-ag.get-fields'] + '?' + this.urlParams({
          pageLink: link
      })).then((response) => {
        this.prevPage = response.data.prevPage;
        this.nextPage = response.data.nextPage;
        this.agFields = response.data.fields;
      }).catch((err) => {
        console.log(err)
      })
    },
    fieldIsImported(id) {
      for (let key in this.importedIds) {
        if (id === this.importedIds[key]) {
          return true;
        }
      }
    }
  }
};

</script>

<template>
  <div class="tile-shadow rounded p-2 bg-primary">
    <div v-if="user.deere_connected_at && page !== 4">
      <p>Click below to manage connections to your organizations.</p>
      <div class="cursor-pointer text-blue">
        <a :href="jdAuthUrl"
           class="button inline-block my-2 bg-primary border-blue hover:bg-grey-lightest focus:bg-grey-lighter">
          <span><i class="fas fa-link"></i></span> Manage Connections
        </a>
      </div>
    </div>
    <div v-if="this.disable">
      Your import is underway! Check back in a few hours for your imported data.
    </div>
    <div v-else>
      <div v-if="page===1">
        <div v-if="tokenUrls">
          <div class="flex flex-col">
            <div>
              <div v-if="activeProvider===2" class="m-4">
                <div class="w-1/3">
                  <img src="/images/logos/JDOC-tm-connected-default.svg" alt="John Deere Connected">
                </div>
                <h2 class="font-semibold mb-2 text-xl">Connect To John Deere</h2>
                <h3>Step 1:</h3>
                <div class="p-2">
                  <p>
                    Click the link below, and login to allow for data sharing. When prompted, connect all organizations you would like to import
                    to "{{ this.orgName }}" (you can always manage these connections later).
                  </p>

                  <a :href="tokenUrls[2]"
                     target="_blank"
                     class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker mt-2 font-bold mr-2">
                    Authenticate with John Deere
                  </a>
                </div>

                <h3>Step 2:</h3>
                <div class="p-2">
                  <p>
                    If you have authenticated with John Deere but have not completed connections, follow the link below to select the organizations you want to share data with. Search for
                    "{{ this.orgName }}", and click <span class="italic">Connect</span>.
                  </p>

                  <a :href="jdAuthUrl"
                     class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker mt-2 font-bold mr-2">
                    Manage Connections
                  </a>
                </div>
              </div>
            </div>

<!--            <div>-->
<!--              <div type="button" @click="activeProvider = 5"-->
<!--                   class="grid grid-cols-3 cursor-pointer bg-grey-lighter rounded-lg p-4 mb-2">-->
<!--                <div class="mr-32">-->
<!--                  <img src="/images/logos/cnhi.png" alt="cnhi">-->
<!--                </div>-->
<!--                <div>-->
<!--                  {{ providers[5] }}-->
<!--                </div>-->
<!--                <div>-->
<!--                  <slot name="is-valid" :valid="activeProviders.includes(5)"></slot>-->
<!--                  {{ activeProviders.includes(5) ? 'Connected' : 'Not Connected' }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div v-if="activeProvider===5" class="m-4">-->
<!--                <h2 class="font-semibold mb-2 text-xl">CNHi</h2>-->
<!--                <h3 class="mb-2 lg">Step 1:</h3>-->
<!--                <div class="p-2">-->
<!--                  <p>-->
<!--                    Click the link below, and login to allow for data sharing.-->
<!--                  </p>-->

<!--                  <a :href="tokenUrls[5]"-->
<!--                     target="_blank"-->
<!--                     class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker mt-2 font-bold mr-2">-->
<!--                    Authenticate with CNHI-->
<!--                  </a>-->
<!--                </div>-->
<!--                <h3>Step 2:</h3>-->
<!--                <div class="p-2">-->
<!--                  <p>-->
<!--                    Once the previous steps are complete, click the button below to begin the import process. Note, will-->
<!--                    take a few hours to complete.-->
<!--                  </p>-->
<!--                  <button type="button"-->
<!--                          class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker mt-2 font-bold mr-2"-->
<!--                          @click="dispatchImport()">-->
<!--                    Initiate Import-->
<!--                  </button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

          </div>

        </div>

        <p v-if="connected">
          <span @click="page=3" class="underline hover:text-blue-dark cursor-pointer">Click here</span> to import fields for connected providers.
        </p>
      </div>
      <div v-if="page===2">
        <h2 class="font-semibold">We are currently connecting your data!</h2>
        <p class="mb-2">Come back later to select specific fields to import. This process can take several minutes.
<!--          <span v-for="provider in activeProviders">{{ providers[provider] }}, </span>-->
        </p>
<!--        <p><span class="underline cursor-pointer" @click="page=1">Click here</span> to connect other farm management-->
<!--          providers.</p>-->
      </div>
      <div v-else-if="page===3">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-2">
          <div>
            <div class="flex">
              <div class="tab-shadow bg-secondary rounded-t text-xl font-semibold p-2">Current Fields</div>
            </div>
            <div class="h-128 bg-secondary tile-shadow rounded-tr rounded-b overflow-scroll p-2 rounded-sm">
              <div v-for="field in currentFields">
                <a :href="routes['home'] + '&farmIndex=' +  farm.id + '&resource_id=' + field.id + '&resource_type=' + 'fields'">
                  {{ field.name }}
                </a>
              </div>
            </div>
            <p class="italic text-sm inline my-auto">Fields marked in green have already been imported</p>
          </div>
          <div>
            <div class="float-right text-lg lg:text-xs">
              <button type="button" @click="toggleCheckFields(true)"
                      class="font-semibold hover:text-blue border rounded-sm border-white px-2 py-1">
                <i class="far fa-check-square"></i>
                Check All
              </button>

              <button type="button" @click="toggleCheckFields(false)"
                      class="font-semibold hover:text-blue border rounded-sm border-white px-2 py-1">
                <i class="far fa-square"></i>
                Uncheck All
              </button>
            </div>
            <div class="flex w-3/4 lg:w-auto">
              <h2 class="tab-shadow bg-secondary rounded-t text-xl font-semibold p-2">Fields to Import From Operations Center</h2>
            </div>
            <form @submit.prevent="importFields" method="post">
              <div class="tile-shadow bg-secondary h-128 overflow-scroll p-2 rounded-sm flex flex-col">
                <template v-if="agFields.length > 0">
                  <div v-for="field in agFields" class="w-full">
                    <label :for="'field-' + field.id"
                           class="py-1 w-full"
                           :class="this.fieldIsImported(field.id) ? 'text-green' : ''">
                      <input type="checkbox" :id="'field-' + field.id" :value="field" v-model="checkedFields">
                      {{ field.name }}
                    </label>
                  </div>
                </template>
                <p v-else class="italic text-grey-light">
                  No fields to import.
                </p>
                <div class="grid grid-cols-3 mt-auto w-full">
                  <div>
                    <button
                        v-if="this.prevPage"
                        type="button"
                        class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker mt-2 font-bold"
                        @click="this.getFields(this.prevPage)">
                      Previous Page
                    </button>
                  </div>
                  <div class="mx-auto text-center">
                    <button
                        v-if="this.prevPage || this.nextPage"
                        type="button"
                        class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker mt-2 font-bold"
                        @click="this.getFields('all')">
                      Show All
                    </button>
                  </div>
                  <div>
                    <button
                        v-if="this.nextPage"
                        type="button"
                        class="float-right px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker mt-2 font-bold"
                        @click="this.getFields(this.nextPage)">
                      Next Page
                    </button>
                  </div>
                </div>
              </div>
              <div class="mt-2">
                <button type="submit"
                        class="float-right button inline-block my-2 bg-primary text-blue border-blue hover:bg-grey-lightest focus:bg-grey-lighter">
                  <i class="fa-solid fa-square-up-right"></i> Submit Selections
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div v-else-if="page===4">
        <p class="mb-2">
          Your fields are being imported. This process may take several minutes while data finishes populating.
          Come back later to review your fields and insert work dates, review crops, and insert other necessary operational data.
        </p>
        <a :href="routes['home']"
           class="button inline-block bg-primary border-blue text-blue hover:bg-grey-lightest focus:bg-grey-lighter">
          <span>Return Home</span>
        </a>
      </div>
    </div>
  </div>
</template>
